import { FormBuilderActionTypes } from './constants';
import { renameDuplicate, renameFieldDuplicate } from '../../utils/renameDuplicate';
import { FindFormIndex } from '../../utils/FindFormIndex';
import { updateFieldById } from '../../utils/updateFieldById';

interface State {
    currentFormId: any,
    formList: any,
    formId: any | "",
    config?: any | {};
    fieldList: any[],
    boadList: any[],
    panelItems: any[],
    expandedKeys: any[]
}

const INIT_STATE = {
    currentFormId: "",
    formList: [],
    formId: "",
    fieldList: [],
    boadList: [],
    panelItems: [],
    subForms: [],
    expandedKeys: [],

    config: {
        publicSettings: {
            tableName: '',
            isShowRownumber: true,
            isFullScreen: true,
            isCustomSort: false,

            orderDataType: 'DESC',
             isWorkFlow: false,
            workFlowId:"",
             isReport: false,

            ReportId:"",

            isShowMenuTree:false,
             dashboardPage:[] ,
             customSortItem:[] ,
            style: {
                width: 600,
                height: 500,
            }
        }
    },
};

const FormBuilder = (state: State = INIT_STATE, action: any): any => {
    // تابع بازگشتی برای برگرداندن index و خود نود

    switch (action.type) {

        case FormBuilderActionTypes.CHANGE_EXPANDKEY:

            return {
                ...state,
                expandedKeys: action.payload,
            };

        case FormBuilderActionTypes.CHANGE_CURRENTFORM:

            const found = FindFormIndex(state.formList, action.payload);

            let s_boadList1 = state.boadList;
            let s_config1 = state.config;
            if (found) {
                s_boadList1 = found.node.boadList || [];
                s_config1 = found.node.config;
            }

            return {
                ...state,
                currentFormId: action.payload,
                boadList: s_boadList1,
                config: s_config1
            };

        case FormBuilderActionTypes.CHANGE_FORMLIST:
            var s_CurrentFormId = state.currentFormId;
            var s_FormList: any = [];
            if (s_CurrentFormId === "")
                s_FormList = action.payload
            else {
                const formIndex = state.formList.findIndex((object: any) => { return object.id === state.currentFormId })
                var s_FormList = state.formList;

                if (formIndex !== -1) {
                    s_FormList[formIndex].children = action.payload
                }
            }
            return {
                ...state,
                formList: s_FormList,
            };

        case FormBuilderActionTypes.CHANGE_ADDFORMLIST:

            return {
                ...state,
                formList: action.payload,
                boadList: [],
                config: {
                    publicSettings: {
                        tableName: '',
                        isShowRownumber: true,
                        isFullScreen:true,
                        isCustomSort: false,
                        orderDataType: 'DESC',
                        isWorkFlow: false,
                        workFlowId:"",
                        isShowMenuTree:false,
                         dashboardPage:[],
                         customSortItem:[] ,
                        style: {
                            width: 400,
                            height: 360,
                        }
                    }
                }

            };

        case FormBuilderActionTypes.CHANGE_RESET_INITIAL_STATE:
            return {
                ...INIT_STATE,
            };

        case FormBuilderActionTypes.CHANGE_FORM_PUBLICSETTING:

            let s_activeKeyRownumber = state.config.publicSettings.activeKey
            if (action.payload.activeKey !== undefined) {
                s_activeKeyRownumber = action.payload.activeKey
            }

            let s_isShowRownumber = state.config.publicSettings.isShowRownumber
            if (action.payload.isShowRownumber !== undefined) {
                s_isShowRownumber = action.payload.isShowRownumber
            }
            let s_isFullScreen = state.config.publicSettings.isFullScreen
            if (action.payload.isFullScreen !== undefined) {
                s_isFullScreen = action.payload.isFullScreen
            }

             let s_isWorkFlow = state.config.publicSettings.isWorkFlow
            if (action.payload.isWorkFlow !== undefined) {
                s_isWorkFlow = action.payload.isWorkFlow
            }
             let s_isReport = state.config.publicSettings.isReport
            if (action.payload.isReport !== undefined) {
                s_isReport = action.payload.isReport
            }
              let s_workFlowId = state.config.publicSettings.workFlowId
            if (action.payload.workFlowId !== undefined) {
                s_workFlowId = action.payload.workFlowId
            }
               let s_ReportId = state.config.publicSettings.ReportId
            if (action.payload.ReportId !== undefined) {
                s_ReportId = action.payload.ReportId
            }
            let s_dashboardPage = state.config.publicSettings.dashboardPage
            if (action.payload.dashboardPage !== undefined) {
                s_dashboardPage = action.payload.dashboardPage
            }
               let s_customSortItem= state.config.publicSettings.customSortItem
            if (action.payload.customSortItem !== undefined) {
                s_customSortItem = action.payload.customSortItem
            }
              let s_isCustomSort = state.config.publicSettings.isCustomSort
            if (action.payload.isCustomSort !== undefined) {
                s_isCustomSort = action.payload.isCustomSort
            }
            let s_isShowMenuTree = state.config.publicSettings.isShowMenuTree
            if (action.payload.isShowMenuTree !== undefined) {
                s_isShowMenuTree = action.payload.isShowMenuTree
            }

            let s_tableName = state.config.publicSettings.tableName
            if (action.payload.tableName !== undefined) {
                s_tableName = action.payload.tableName
            }


            let s_orderDataType = state.config.publicSettings.orderDataType
            if (action.payload.orderDataType !== undefined) {
                s_orderDataType = action.payload.orderDataType
            }

            let s_styleWidth = state?.config?.publicSettings.style?.width
            if (action?.payload?.style?.width !== undefined) {
                s_styleWidth = action?.payload?.style?.width
            }

                 let s_styleHight = state?.config?.publicSettings?.style?.height
            if (action?.payload?.style?.height !== undefined) {
                s_styleHight = action?.payload?.style?.height
            }

            let s_filePath = state.config.publicSettings.filePath
            if (action.payload.filePath !== undefined) {
                s_filePath = action.payload.filePath
            }

            const s_Config = {
                ...state.config,
                publicSettings: { ...state.config.publicSettings, activeKey: s_activeKeyRownumber, tableName: s_tableName, isFullScreen: s_isFullScreen, isShowRownumber: s_isShowRownumber,isWorkFlow:s_isWorkFlow,isReport:s_isReport,isShowMenuTree:s_isShowMenuTree,isCustomSort:s_isCustomSort,workFlowId:s_workFlowId,ReportId:s_ReportId,dashboardPage:s_dashboardPage,customSortItem:s_customSortItem, orderDataType: s_orderDataType,filePath:s_filePath,style: {width: s_styleWidth,height:s_styleHight } }
            }
            const s_FormListC = [...state.formList]; // shallow copy سطح اول

            const foundC = FindFormIndex(s_FormListC, state.currentFormId);

            if (foundC) {
                foundC.node.config = s_Config;  // تغییر مستقیم روی نود پیدا شده
            }

            return {
                ...state,
                config: s_Config,
            };

        case FormBuilderActionTypes.CHANGE_FORM_TABLENAME:
            return {
                ...state,
                config: { ...state.config, tableName: action.payload?.tableName },
            };

        case FormBuilderActionTypes.CHANGE_FORMID:
            return {
                ...state,
                formId: action.payload,
            };

        case FormBuilderActionTypes.CHANGE_FIELD:
            return {
                ...state,
                fieldList: action.payload,
            };

        // case FormBuilderActionTypes.CHANGE_BOAD:
        //     var t1 = renameFieldDuplicate(action.payload);
        //     return {
        //         ...state,
        //         boadList: t1,
        //     };

        case FormBuilderActionTypes.CHANGE_BOAD: {
            const s_FormList = [...state.formList]; // shallow copy سطح اول
            const t1 = renameFieldDuplicate(action.payload);

            const found = FindFormIndex(s_FormList, state.currentFormId);

            if (found) {
                found.node.boadList = t1;  // تغییر مستقیم روی نود پیدا شده
            }

            return {
                ...state,
                formList: s_FormList,
                boadList: t1,
            };
        }

        case FormBuilderActionTypes.CHANGE_FORM_SUBFORM:
            return {
                ...state,
                subForms: action.payload,
            };

        // case FormBuilderActionTypes.CHANGE_BOAD_SETTING:
        //     const boadIndex = state.boadList.findIndex(object => { return object.id === action.payload.id })
        //     const s_boadList = state.boadList;
        //     const ddd = s_boadList

        //     if (boadIndex !== -1) {
        //         s_boadList[boadIndex] = { ...s_boadList[boadIndex], ...action.payload }
        //     }

        //     return {
        //         ...state,
        //         boadList: s_boadList,
        //     };

        // case FormBuilderActionTypes.CHANGE_BOAD_SETTING: {
        //     let foundBoadIndex = -1;
        //     let foundFieldIndex = -1;

        //     state.boadList.forEach((item, boardIndex) => {
        //         const fieldIndex = item.fields.findIndex((object: any) => { return object.id === action.payload.id })

        //         //   item.fields.findIndex(
        //         //     (f: any) => f.id === action.payload.id
        //         //   );
        //         if (fieldIndex !== -1) {
        //             foundBoadIndex = boardIndex;
        //             foundFieldIndex = fieldIndex;
        //         }
        //     });


        //     if (foundBoadIndex === -1 || foundFieldIndex === -1) return state;


        //     const newBoadList = state.boadList.map((boad, i) => {
        //         if (i === foundBoadIndex) {
        //             const newFields = boad.fields.map((field: any, j: any) => {
        //                 if (j === foundFieldIndex) {
        //                     return { ...field, ...action.payload };
        //                 }
        //                 return field;
        //             });
        //             return { ...boad, fields: newFields };
        //         }
        //         return boad;
        //     });
        //     return {
        //         ...state,
        //         boadList: newBoadList,
        //     };
        // }

        case FormBuilderActionTypes.CHANGE_BOAD_SETTING: {
            const { id, ...updates } = action.payload;
            const d=updateFieldById(state.boadList, id, updates)

            const s_FormList = [...state.formList]; // shallow copy سطح اول

            const found = FindFormIndex(s_FormList, state.currentFormId);

            if (found) {
                found.node.boadList = d;  // تغییر مستقیم روی نود پیدا شده
            }

            return {
              ...state,
              formList:s_FormList,
              boadList: d,
            };
          }

        default:
            return state;
    }
};

export default FormBuilder;
